export default __webpack_public_path__ + "static/media/2-3-2.c82bbc29.webp";